module.exports = __webpack_public_path__ + "static/media/list-unordered.39fd7dbe.svg";